import { ReportConfig } from '../../types';

export const DEFAULT_REPORT_CONFIG: ReportConfig = {
  successRate: 50,
  dropOffRate: 20,
  missclickRate: 20,
  timeToSuccess: 40,
  minimumHumanParticipants: 0,
  minimumAiParticipants: 10,
};

const isEmpty = (val?: number | null) =>
  val === null || typeof val === 'undefined';

export const normalizeConfig = (
  data?: Partial<ReportConfig> | null
): { config: ReportConfig } => {
  if (!data) {
    return { config: DEFAULT_REPORT_CONFIG };
  }

  const config: ReportConfig = {
    ...data,
    successRate: isEmpty(data.successRate)
      ? DEFAULT_REPORT_CONFIG.successRate
      : data.successRate!,
    dropOffRate: isEmpty(data.dropOffRate)
      ? DEFAULT_REPORT_CONFIG.dropOffRate
      : data.dropOffRate!,
    missclickRate: isEmpty(data.missclickRate)
      ? DEFAULT_REPORT_CONFIG.missclickRate
      : data.missclickRate!,
    timeToSuccess: isEmpty(data.timeToSuccess)
      ? DEFAULT_REPORT_CONFIG.timeToSuccess
      : data.timeToSuccess!,
    minimumHumanParticipants: isEmpty(data.minimumHumanParticipants)
      ? DEFAULT_REPORT_CONFIG.minimumHumanParticipants
      : data.minimumHumanParticipants!,
    minimumAiParticipants: isEmpty(data.minimumAiParticipants)
      ? DEFAULT_REPORT_CONFIG.minimumAiParticipants
      : data.minimumAiParticipants!,
  };

  return { config };
};
